import { FC } from 'react'
import styled from '@emotion/styled'

const Select = styled('select')(({ theme }) => ({
  font: 'inherit',
  padding: `${theme.spacing.xs + 2}px ${theme.spacing.xs}px`,
  border: '1px solid transparent',
  borderRadius: 0,
  background: 'none',
  color: theme.colors.text.primary,
  cursor: 'pointer',
  width: '100%',
  textAlign: 'center',
  appearance: 'none',
  '&:hover': {
    borderColor: theme.colors.primary.main,
  },
  '&:focus': {
    borderColor: theme.colors.primary.main,
  },
}))

interface PreviewUnitSelectProps {
  units: string[]
  selectedIndex: number
  onChange: (index: number) => void
  onFocus?: () => void
}

export const PreviewUnitSelect: FC<PreviewUnitSelectProps> = ({ units, selectedIndex, onChange, onFocus }) => {
  return (
    <Select value={selectedIndex} onChange={(e) => onChange(Number(e.target.value))} onFocus={onFocus}>
      {units.map((unit, i) => (
        <option key={i} value={i}>
          {unit}
        </option>
      ))}
    </Select>
  )
}
